import { InjectionToken } from '@angular/core';

export const RED_MEDIA_STORAGE= new InjectionToken<any>('redMediaStorage');
